import type { PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

export const IconCircleCheckedFilled: FC<PropsWithClassName> = ({ className }) => {
    return (
        <svg
            className={className}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Circle background */}
            <circle cx="10" cy="10" r="9" fill="currentColor" />
            {/* Checkmark with thicker stroke */}
            <path
                d="M6 10L8.5 12.5L14 7"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </svg>
    );
};
